import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typestatus";
var post = "/typestatus";
export const actGetDataTypestatus = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPESTATUS" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPESTATUS",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_TYPESTATUS", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPESTATUS",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTypestatus = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPESTATUS" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Status type has been created");
          dispatch(__openModal({ modal: "MODAL_ADD_TYPESTATUS", open: false }));
          return dispatch(actGetDataTypestatus());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPESTATUS", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPESTATUS",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTypestatus = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPESTATUS" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Status type has been update");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPESTATUS", open: false })
          );
          return dispatch(actGetDataTypestatus());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPESTATUS", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPESTATUS",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTypestatus = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPESTATUS" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPESTATUS",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_TYPESTATUS", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPESTATUS",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTypestatus = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPESTATUS" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Status type has been deleted");
          dispatch(__openModal({ moal: "MODAL_ADD_TYPESTATUS", open: false }));
          return dispatch(actGetDataTypestatus());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPESTATUS", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPESTATUS",
          message: "Network error..",
        });
      });
  };
};
